module.exports = __webpack_public_path__ + "img/Kclubs.bd8311e3.jpg";